// Настройка GrapesJS под письма: блоки из ТЗ, редактируемые HTML- и видео-блоки,
// сборка итогового HTML письма (CSS встраивается в теги + адаптив в <style>).

export const UNSUBSCRIBE_RE = /href\s*=\s*["']\s*\{\{\s*unsubscribe_url\s*\}\}\s*["']/i;

export const hasUnsubscribe = (html) => UNSUBSCRIBE_RE.test(html || '');

// Текст в блоках — <div>, не <p>: кнопки списков в панели текста вставляют <ul>
// прямо в элемент, а <ul> внутри <p> невалиден — при разборе письма <p> закрывается
// перед списком, остаются пустые абзацы с отступами, а сам список теряет шрифт.
const FONT = 'font-family: Arial, Helvetica, sans-serif;';

// Колонки складываются в одну на экранах уже 600px.
const RESPONSIVE_CSS = `
@media only screen and (max-width: 600px) {
  .email-col { display: block !important; width: 100% !important; box-sizing: border-box; }
  .email-container { width: 100% !important; }
  img { max-width: 100% !important; height: auto !important; }
}`;

export const SOCIAL = ['facebook', 'instagram', 'x', 'telegram', 'youtube', 'tiktok', 'whatsapp', 'viber', 'vk', 'discord'];
export const ICONS = ['gift', 'star', 'trophy', 'zap', 'clock', 'circlecheck', 'percent', 'calendar', 'heart', 'flame'];

export const iconUrl = (base, name) => `${base}/email-icons/${name}.png`;

const columns = (count, widths) => {
  const cells = widths
    .map(
      (w) =>
        `<td class="email-col" width="${w}%" style="width:${w}%;padding:10px;vertical-align:top;">` +
        `<div style="${FONT}font-size:15px;line-height:1.5;color:#374151;margin:0;">Column content</div></td>`
    )
    .join('');
  return `<table class="email-row" width="100%" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tr>${cells}</tr></table>`;
};

const socialRow = (base) => {
  const cells = ['facebook', 'instagram', 'x', 'telegram', 'youtube']
    .map(
      (n) =>
        `<td style="padding:0 6px;"><a href="https://${n === 'x' ? 'x' : n}.com/" target="_blank">` +
        `<img src="${iconUrl(base, n)}" width="32" height="32" alt="${n}" style="display:block;border:0;width:32px;height:32px;"/></a></td>`
    )
    .join('');
  return `<table align="center" cellpadding="0" cellspacing="0" role="presentation" style="margin:16px auto;"><tr>${cells}</tr></table>`;
};

const iconsRow = (base) => {
  const cells = [
    ['gift', 'Welcome bonus'],
    ['trophy', 'Top odds'],
    ['zap', 'Fast payouts']
  ]
    .map(
      ([icon, text]) =>
        `<td class="email-col" width="33%" style="width:33%;padding:10px;text-align:center;vertical-align:top;">` +
        `<img src="${iconUrl(base, `icon${icon}`)}" width="40" height="40" alt="${icon}" style="display:inline-block;border:0;width:40px;height:40px;"/>` +
        `<div style="${FONT}font-size:14px;color:#374151;margin:8px 0 0;">${text}</div></td>`
    )
    .join('');
  return `<table class="email-row" width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr>${cells}</tr></table>`;
};

export const starterTemplate = (base) => `
<table class="email-container" width="600" align="center" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;max-width:100%;margin:0 auto;background:#ffffff;">
  <tr><td style="padding:32px 32px 8px;">
    <h1 style="${FONT}font-size:28px;line-height:1.25;color:#111827;margin:0 0 12px;">Your title</h1>
    <div style="${FONT}font-size:16px;line-height:1.6;color:#374151;margin:0 0 20px;">Write the main text of the email here.</div>
    <a href="https://example.com" style="${FONT}display:inline-block;background:#2563eb;color:#ffffff;font-size:16px;font-weight:bold;text-decoration:none;padding:12px 28px;border-radius:6px;">Get the bonus</a>
  </td></tr>
  <tr><td style="padding:24px 32px 32px;">
    ${socialRow(base)}
    <div style="${FONT}font-size:12px;line-height:1.5;color:#6b7280;text-align:center;margin:0;">You received this email because you are registered with us.<br/><a href="{{unsubscribe_url}}" style="color:#6b7280;">Unsubscribe</a></div>
  </td></tr>
</table>`;

export const registerEmailBlocks = (editor, base) => {
  const bm = editor.BlockManager;
  const cat = { layout: 'Layout', content: 'Content', media: 'Media' };

  bm.add('columns-1', { label: '1 column', category: cat.layout, content: columns(1, [100]),
    media: '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="1" fill="none" stroke="currentColor"/></svg>' });
  bm.add('columns-2', { label: '2 columns', category: cat.layout, content: columns(2, [50, 50]),
    media: '<svg viewBox="0 0 24 24"><rect x="2" y="5" width="9" height="14" rx="1" fill="none" stroke="currentColor"/><rect x="13" y="5" width="9" height="14" rx="1" fill="none" stroke="currentColor"/></svg>' });
  bm.add('columns-3', { label: '3 columns', category: cat.layout, content: columns(3, [33, 34, 33]),
    media: '<svg viewBox="0 0 24 24"><rect x="1" y="5" width="6" height="14" rx="1" fill="none" stroke="currentColor"/><rect x="9" y="5" width="6" height="14" rx="1" fill="none" stroke="currentColor"/><rect x="17" y="5" width="6" height="14" rx="1" fill="none" stroke="currentColor"/></svg>' });
  bm.add('columns-37', { label: '30 / 70', category: cat.layout, content: columns(2, [30, 70]),
    media: '<svg viewBox="0 0 24 24"><rect x="2" y="5" width="6" height="14" rx="1" fill="none" stroke="currentColor"/><rect x="10" y="5" width="12" height="14" rx="1" fill="none" stroke="currentColor"/></svg>' });

  bm.add('title', { label: 'Title', category: cat.content,
    content: `<h1 style="${FONT}font-size:28px;line-height:1.25;color:#111827;margin:0 0 12px;">Your title</h1>`,
    media: '<svg viewBox="0 0 24 24"><text x="4" y="17" font-size="14" font-weight="bold" fill="currentColor">H1</text></svg>' });
  bm.add('paragraph', { label: 'Text', category: cat.content,
    content: `<div style="${FONT}font-size:16px;line-height:1.6;color:#374151;margin:0 0 16px;">Insert your text here</div>`,
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M4 6h16v2H4zm0 5h16v2H4zm0 5h10v2H4z"/></svg>' });
  bm.add('list-bullet', { label: 'Bulleted list', category: cat.content,
    content: `<ul style="${FONT}font-size:16px;line-height:1.6;color:#374151;margin:0 0 16px;padding-left:24px;"><li>First item</li><li>Second item</li><li>Third item</li></ul>`,
    media: '<svg viewBox="0 0 24 24"><circle cx="5" cy="7" r="1.5" fill="currentColor"/><circle cx="5" cy="12" r="1.5" fill="currentColor"/><circle cx="5" cy="17" r="1.5" fill="currentColor"/><path fill="currentColor" d="M9 6h11v2H9zm0 5h11v2H9zm0 5h11v2H9z"/></svg>' });
  bm.add('list-number', { label: 'Numbered list', category: cat.content,
    content: `<ol style="${FONT}font-size:16px;line-height:1.6;color:#374151;margin:0 0 16px;padding-left:24px;"><li>First step</li><li>Second step</li><li>Third step</li></ol>`,
    media: '<svg viewBox="0 0 24 24"><text x="2" y="9" font-size="6" fill="currentColor">1.</text><text x="2" y="15" font-size="6" fill="currentColor">2.</text><text x="2" y="21" font-size="6" fill="currentColor">3.</text><path fill="currentColor" d="M9 6h11v2H9zm0 6h11v2H9zm0 6h11v2H9z"/></svg>' });
  bm.add('cta-button', { label: 'Button', category: cat.content,
    content: `<table align="center" cellpadding="0" cellspacing="0" role="presentation" style="margin:8px auto 16px;"><tr><td style="border-radius:6px;background:#2563eb;"><a href="https://example.com" style="${FONT}display:inline-block;color:#ffffff;font-size:16px;font-weight:bold;text-decoration:none;padding:12px 28px;border-radius:6px;">Click here</a></td></tr></table>`,
    media: '<svg viewBox="0 0 24 24"><rect x="3" y="8" width="18" height="8" rx="3" fill="none" stroke="currentColor"/></svg>' });
  bm.add('email-divider', { label: 'Divider', category: cat.content,
    content: '<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;margin:16px 0;"><tr><td style="border-top:1px solid #e5e7eb;font-size:0;line-height:0;height:1px;">&nbsp;</td></tr></table>',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 11h18v2H3z"/></svg>' });
  bm.add('unsubscribe', { label: 'Unsubscribe', category: cat.content,
    content: `<div style="${FONT}font-size:12px;line-height:1.5;color:#6b7280;text-align:center;margin:16px 0;">You received this email because you are registered with us. <a href="{{unsubscribe_url}}" style="color:#6b7280;">Unsubscribe</a></div>`,
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 5h18v14H3zm2 2v.5l7 4.5 7-4.5V7zm0 3v7h14v-7l-7 4.5z"/></svg>' });
  bm.add('html-block', { label: 'HTML', category: cat.content,
    content: { type: 'html-block', components: '<p style="margin:0;">Custom HTML — double-click to edit</p>' },
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M8.6 16.6 4 12l4.6-4.6L10 8.8 6.8 12l3.2 3.2zm6.8 0L20 12l-4.6-4.6L14 8.8l3.2 3.2-3.2 3.2z"/></svg>' });

  bm.add('email-image', { label: 'Image', category: cat.media, activate: true, select: true,
    content: { type: 'image', style: { display: 'block', 'max-width': '100%', margin: '0 auto' }, attributes: { alt: '' } },
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M21 19V5H3v14zM8.5 13.5l2.5 3 3.5-4.5 4.5 6H5z"/></svg>' });
  bm.add('video', { label: 'Video', category: cat.media,
    content: { type: 'video-link' },
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M10 8v8l6-4zM3 5h18v14H3z" fill-rule="evenodd"/></svg>' });
  bm.add('social', { label: 'Social', category: cat.media, content: socialRow(base),
    media: '<svg viewBox="0 0 24 24"><circle cx="6" cy="12" r="3" fill="currentColor"/><circle cx="12" cy="12" r="3" fill="currentColor"/><circle cx="18" cy="12" r="3" fill="currentColor"/></svg>' });
  bm.add('icons', { label: 'Icons', category: cat.media, content: iconsRow(base),
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="m12 3 2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.6 6.6 19.5l1.2-6-4.5-4.2 6.1-.7z"/></svg>' });
};

const youtubeId = (url) => {
  const m = String(url || '').match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
};

// Блок HTML: произвольная разметка, правится двойным кликом в модальном окне.
// Видео: в письмах видео не проигрывается — это превью-картинка со ссылкой на ролик.
export const registerEmailComponents = (editor, base) => {
  editor.DomComponents.addType('html-block', {
    isComponent: (el) => el.getAttribute && el.getAttribute('data-html-block') === '1',
    model: {
      defaults: { tagName: 'div', attributes: { 'data-html-block': '1' }, droppable: false, editable: false },
      // Содержимое — одна цельная вставка: без этого клик попадает во внутренний
      // элемент, редактор выделяет его как обычный текст, и окно правки HTML не открыть.
      init() {
        this.lockChildren();
        this.listenTo(this.components(), 'add reset', this.lockChildren);
      },
      lockChildren() {
        const lock = (component) => {
          component.set({
            selectable: false, hoverable: false, highlightable: false, editable: false,
            draggable: false, droppable: false, copyable: false, removable: false, layerable: false
          });
          component.components().forEach(lock);
        };
        this.components().forEach(lock);
      }
    },
    view: {
      events: { dblclick: 'openEditor' },
      openEditor() {
        const model = this.model;
        const wrap = document.createElement('div');
        const area = document.createElement('textarea');
        area.value = model.getInnerHTML();
        area.style.cssText = 'width:100%;height:320px;font-family:monospace;font-size:13px;padding:8px;color:#111;';
        const save = document.createElement('button');
        save.textContent = 'Apply';
        save.style.cssText = 'margin-top:10px;padding:8px 18px;background:#2563eb;color:#fff;border:0;border-radius:4px;cursor:pointer;';
        save.onclick = () => {
          model.components(area.value);
          editor.Modal.close();
        };
        wrap.appendChild(area);
        wrap.appendChild(save);
        editor.Modal.open({ title: 'Edit HTML block', content: wrap });
      }
    }
  });

  // Ссылка на картинку (ТЗ, «Работа с изображениями»): поле Link URL в настройках
  // картинки. Адрес оборачивает картинку в <a>, пустое поле снимает обёртку.
  // Картинки видео-блока не трогаем — их ссылка задаётся на самом блоке.
  // Картинка пересоздаётся внутри/вне обёртки, и выделение переносится на новую.
  // Пресет на выделение открывает панель стилей — возвращаем настройки компонента,
  // где пользователь только что ввёл адрес.
  const selectKeepingSettings = (component) => {
    editor.select(component);
    editor.Panels.getButton('views', 'open-tm')?.set('active', true);
  };

  const linkParent = (image) => {
    const parent = image.parent();
    return parent && parent.get('tagName') === 'a' && parent.components().length === 1 ? parent : null;
  };

  editor.DomComponents.addType('image', {
    model: {
      init() {
        const parent = this.parent();
        if (parent && parent.getAttributes()['data-video-block'] === '1') return;

        this.addTrait({ type: 'text', name: 'link-href', label: 'Link URL', changeProp: true, placeholder: 'https://…' });
        this.on('change:link-href', this.applyLink);
      },
      // Родителя при создании компонента ещё нет, поэтому значение поля читается
      // из обёртки при выделении картинки (см. component:selected ниже).
      syncLinkField() {
        const link = linkParent(this);
        this.set('link-href', link ? link.getAttributes().href || '' : '', { silent: true });
      },
      applyLink() {
        const href = (this.get('link-href') || '').trim();
        const link = linkParent(this);

        if (link && href) {
          link.addAttributes({ href, target: '_blank' });
        } else if (link && !href) {
          const container = link.parent();
          const at = link.index();
          const [image] = container.append(this.clone(), { at });
          link.remove();
          selectKeepingSettings(image);
        } else if (!link && href) {
          const container = this.parent();
          const at = this.index();
          const [wrapper] = container.append(
            { type: 'link', attributes: { href, target: '_blank' }, style: { display: 'block', 'text-align': 'center' } },
            { at }
          );
          wrapper.append(this.clone());
          this.remove();
          selectKeepingSettings(wrapper.components().at(0));
        }
      }
    }
  });

  editor.on('component:selected', (component) => {
    if (component && component.syncLinkField && component.getTrait('link-href')) {
      component.syncLinkField();
      component.getTrait('link-href').view?.render?.();
    }
  });

  editor.DomComponents.addType('video-link', {
    isComponent: (el) => el.tagName === 'A' && el.getAttribute('data-video-block') === '1',
    extend: 'link',
    model: {
      defaults: {
        tagName: 'a',
        droppable: false,
        attributes: { 'data-video-block': '1', href: 'https://www.youtube.com/', target: '_blank' },
        style: { display: 'block', 'text-align': 'center', 'text-decoration': 'none' },
        traits: [{ type: 'text', name: 'href', label: 'Video URL', changeProp: false }],
        components: `<img src="${iconUrl(base, 'youtube')}" alt="Watch video" width="96" style="display:block;margin:0 auto;border:0;max-width:100%;"/><div style="${FONT}font-size:14px;color:#2563eb;margin:8px 0 0;">▶ Watch video</div>`
      },
      init() {
        this.on('change:attributes:href', this.updateThumbnail);
      },
      updateThumbnail() {
        const id = youtubeId(this.getAttributes().href);
        const img = this.find('img')[0];
        if (!id || !img) return;
        img.setAttributes({ ...img.getAttributes(), src: `https://img.youtube.com/vi/${id}/hqdefault.jpg`, width: '560' });
        img.setStyle({ ...img.getStyle(), width: '100%', 'max-width': '560px' });
      }
    }
  });
};

export const registerRteActions = (editor) => {
  const rte = editor.RichTextEditor;
  rte.add('ulist', { icon: '•≡', attributes: { title: 'Bulleted list' }, result: (r) => r.exec('insertUnorderedList') });
  rte.add('olist', { icon: '1≡', attributes: { title: 'Numbered list' }, result: (r) => r.exec('insertOrderedList') });
  rte.add('color', {
    icon: '<span style="font-weight:bold;color:#dc2626;">A</span>',
    attributes: { title: 'Text color' },
    // Палитра браузера: выделение в iframe холста при этом не теряется.
    result: (r) => {
      const input = document.createElement('input');
      input.type = 'color';
      input.value = '#dc2626';
      input.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
      document.body.appendChild(input);
      input.addEventListener('change', () => {
        r.exec('foreColor', input.value);
        input.remove();
      });
      input.addEventListener('blur', () => setTimeout(() => input.remove(), 500));
      input.click();
    }
  });
};

export const buildEmailHtml = (editor) => {
  const body = editor.runCommand('gjs-get-inlined-html') || editor.getHtml();
  const css = editor.getCss({ avoidProtected: true }) || '';
  const inner = body.replace(/^\s*<body[^>]*>/i, '').replace(/<\/body>\s*$/i, '');
  return (
    '<!DOCTYPE html>\n<html>\n<head>\n<meta charset="utf-8">\n' +
    '<meta name="viewport" content="width=device-width, initial-scale=1">\n' +
    '<meta name="x-apple-disable-message-reformatting">\n' +
    `<style>${RESPONSIVE_CSS}\n${css}</style>\n</head>\n` +
    `<body style="margin:0;padding:0;background:#f3f4f6;">\n${inner}\n</body>\n</html>`
  );
};

// Письмо из HTML-режима обратно в визуальный: тело — в компоненты, <style> — в CSS.
export const loadHtmlIntoEditor = (editor, html) => {
  const source = html || '';
  const styles = [...source.matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi)]
    .map((m) => m[1])
    .join('\n')
    .replace(RESPONSIVE_CSS, '');
  const bodyMatch = source.match(/<body[^>]*>([\s\S]*)<\/body>/i);
  const body = bodyMatch ? bodyMatch[1] : source.replace(/<head[\s\S]*?<\/head>/i, '').replace(/<\/?html[^>]*>/gi, '');
  // Порядок важен: GrapesJS превращает inline-стили компонентов в CSS-правила,
  // и setStyle после setComponents стёр бы их.
  editor.setStyle(styles);
  editor.setComponents(body);
};
